import CssBaseline from '@mui/material/CssBaseline';
import { makeStyles } from '@mui/styles';
import { TFunction } from 'i18next';
import React from 'react';

import Header from './components/layout-header/layout-header';
import { APP_HEADER_HEIGHT_MD } from './constants';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    padding: 0,
  },
  content: {
    maxWidth: "100%",
    flexGrow: 1,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    width: theme.spacing(30),
    height: theme.spacing(7),
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      height: APP_HEADER_HEIGHT_MD,
    },
  },
}));

type AuthenticatedLayoutSceneProps = {
  t: TFunction;
  agencySelected: string;
  selectAgency: (agencyId: string) => void;
  location: any;
  userIsTitleAdmin: boolean;
  currentLanguageCode: string;
  userLetters: string;
  anchorEl: HTMLElement | null;
  isMenuOpen: boolean;
  handleRoute: (path: string) => void;
  handleLanguage: (language: string) => void;
  handleProfileMenuOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleNavigateProfile: () => void;
  handleNavigateTermsOfService: () => void;
  handleLogout: () => void;
  handleClose: () => void;
  children: React.ReactNode;
  handleTemplateClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  templateAnchorEl: HTMLElement | null;
  handleOpenAiUsage: (email: string | null) => void;
};

const AuthenticatedLayoutScene = ({
  t,
  agencySelected,
  selectAgency,
  location,
  userIsTitleAdmin,
  currentLanguageCode,
  userLetters,
  anchorEl,
  isMenuOpen,
  handleRoute,
  handleLanguage,
  handleProfileMenuOpen,
  handleNavigateProfile,
  handleNavigateTermsOfService,
  handleLogout,
  handleClose,
  children,
  handleTemplateClick,
  templateAnchorEl,
  handleOpenAiUsage,
}: AuthenticatedLayoutSceneProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />

      {!location.pathname.includes('/file') && (
        <Header
          t={t}
          agencySelected={agencySelected}
          selectAgency={selectAgency}
          location={location}
          userIsTitleAdmin={userIsTitleAdmin}
          currentLanguageCode={currentLanguageCode}
          userLetters={userLetters}
          anchorEl={anchorEl}
          isMenuOpen={isMenuOpen}
          handleRoute={handleRoute}
          handleLanguage={handleLanguage}
          handleProfileMenuOpen={handleProfileMenuOpen}
          handleNavigateProfile={handleNavigateProfile}
          handleNavigateTermsOfService={handleNavigateTermsOfService}
          handleLogout={handleLogout}
          handleClose={handleClose}
          handleTemplateClick={handleTemplateClick}
          templateAnchorEl={templateAnchorEl}
          handleOpenAiUsage={handleOpenAiUsage}
        />
      )}

      <main className={classes.content}>
        {!location.pathname.includes('/file') && <div className={classes.toolbar} />}

        {/* display: contents keeps this marker out of the box tree, so view layout is unchanged. */}
        <div data-screen-root style={{ display: 'contents' }}>{children}</div>
      </main>
    </div>
  );
};

export default AuthenticatedLayoutScene;
